var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.01523 9.51125C7.92773 9.5025 7.82273 9.5025 7.72648 9.51125C5.64398 9.44125 3.99023 7.735 3.99023 5.635C3.99023 3.49125 5.72273 1.75 7.87523 1.75C10.019 1.75 11.7602 3.49125 11.7602 5.635C11.7515 7.735 10.0977 9.44125 8.01523 9.51125Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3589 3.5C16.0564 3.5 17.4214 4.87375 17.4214 6.5625C17.4214 8.21625 16.1089 9.56375 14.4726 9.625C14.4026 9.61625 14.3239 9.61625 14.2451 9.625",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63988 12.74C1.52238 14.1575 1.52238 16.4675 3.63988 17.8762C6.04613 19.4862 9.99238 19.4862 12.3986 17.8762C14.5161 16.4587 14.5161 14.1488 12.3986 12.74C10.0011 11.1388 6.05488 11.1388 3.63988 12.74Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0479 17.5C16.6779 17.3687 17.2729 17.115 17.7629 16.7387C19.1278 15.715 19.1278 14.0262 17.7629 13.0025C17.2816 12.635 16.6954 12.39 16.0741 12.25",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowers);
export default __webpack_public_path__ + "static/media/followers.036b7abab036a98df64c4dfd92e05b73.svg";
export { ForwardRef as ReactComponent };